var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHello(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -781.306,
    cy: -556.8061,
    gradientTransform: "matrix(0.7071 -0.7071 0.7071 0.7071 989.5429 -120.8126)",
    gradientUnits: "userSpaceOnUse",
    r: 89.8366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3533,
    style: {
      stopColor: "#FFCA28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8723,
    style: {
      stopColor: "#FFB300"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,117c-5.45,0-10.73-2.01-15.71-6c-3.95-3.17-44.19-42.4-44.6-42.79 c-1.62-1.62-2.64-3.3-2.92-4.84c-0.29-1.6,0.2-3,1.5-4.3c1.21-1.21,2.69-1.85,4.28-1.85c1.94,0,3.93,0.92,5.59,2.59l16.63,15.98 c0.29,0.28,0.67,0.42,1.04,0.42c0.39,0,0.77-0.15,1.06-0.44c0.58-0.58,0.58-1.52,0.01-2.1L19.13,46.25 c-2.66-2.66-3.91-6.73-0.75-9.89c1.21-1.21,2.69-1.85,4.28-1.85c1.94,0,3.93,0.92,5.59,2.59l27.16,26.48 c0.29,0.28,0.67,0.43,1.05,0.43c0.38,0,0.77-0.15,1.06-0.44c0.58-0.58,0.59-1.52,0.01-2.11L24.91,28.02 c-1.51-1.51-2.42-3.32-2.58-5.08c-0.15-1.79,0.48-3.45,1.83-4.8c1.21-1.21,2.69-1.85,4.28-1.85c1.94,0,3.93,0.92,5.59,2.58 l33.27,32.44c0.29,0.28,0.67,0.43,1.05,0.43c0.38,0,0.77-0.15,1.06-0.44c0.58-0.58,0.59-1.52,0.01-2.11L45.26,24.36 c-1.52-1.52-2.43-3.32-2.58-5.08c-0.15-1.79,0.48-3.45,1.83-4.8c1.21-1.21,2.69-1.85,4.28-1.85c1.94,0,3.93,0.92,5.59,2.59 c8.86,8.7,31.99,31.45,32.77,32.29c0.62,0.75,1.33,0.92,1.8,0.92c1.74,0,2.66-2.03,2.81-4.04c0.17-2.34-0.45-5.13-1.11-8.08 c-0.82-3.68-1.67-7.49-0.73-9.72c1.85-4.38,6.13-7.92,8.43-7.92c0.23,0,0.43,0.04,0.6,0.12c4.14,1.94,3.99,4.43,3.19,10.38 l-0.15,1.15c-0.77,5.92,2.32,13.35,5.04,19.91c1.11,2.67,2.16,5.2,2.89,7.46c0.44,1.37,1.11,2.83,1.89,4.52 c4.15,9.08,10.43,22.79-9.91,43.13C94.13,113.08,86.36,117,78.8,117C78.8,117,78.8,117,78.8,117z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.79,14.12c1.52,0,3.17,0.78,4.55,2.16C65.9,28.63,84.85,47.26,86.03,48.5 c1.07,1.23,2.28,1.42,2.92,1.42c2.34,0,4.07-2.18,4.3-5.44c0.18-2.56-0.46-5.45-1.14-8.51c-0.73-3.29-1.57-7.02-0.81-8.81 c1.7-4.02,5.61-6.97,7.07-7c2.99,1.42,3.09,2.76,2.28,8.8l-0.15,1.15c-0.82,6.32,2.35,13.95,5.14,20.67 c1.1,2.64,2.13,5.14,2.85,7.34c0.47,1.45,1.19,3.02,1.95,4.68c2,4.38,4.5,9.83,4.1,16.51c-0.48,8.04-4.96,16.2-13.71,24.94 c-7.47,7.47-14.88,11.26-22.03,11.26c-5.1,0-10.07-1.91-14.77-5.68c-3.23-2.59-33.21-31.7-44.46-42.67 c-2.82-2.82-3.3-5.19-1.44-7.04c0.94-0.94,2.02-1.41,3.22-1.41c1.52,0,3.17,0.78,4.53,2.15c0.01,0.01,0.03,0.03,0.04,0.04 l16.61,15.96c0.58,0.56,1.33,0.84,2.08,0.84c0.77,0,1.54-0.3,2.13-0.88c1.15-1.16,1.17-3.03,0.03-4.2L20.18,45.17 c-1.25-1.25-2.01-2.72-2.13-4.14c-0.12-1.36,0.35-2.57,1.39-3.61c0.94-0.94,2.02-1.41,3.22-1.41c1.52,0,3.17,0.78,4.56,2.17 l27.15,26.46c0.58,0.57,1.34,0.85,2.09,0.85c0.77,0,1.54-0.29,2.12-0.88c1.16-1.16,1.17-3.04,0.03-4.22L25.96,26.95 c-3.13-3.13-2.35-6.13-0.73-7.75c0.94-0.94,2.02-1.41,3.22-1.41c1.52,0,3.17,0.78,4.56,2.17l33.26,32.43 c0.58,0.57,1.34,0.85,2.09,0.85c0.77,0,1.54-0.29,2.12-0.88c1.16-1.16,1.17-3.04,0.03-4.21l-24.2-24.86 c-1.25-1.25-2.01-2.72-2.13-4.14c-0.12-1.36,0.35-2.57,1.39-3.61C46.51,14.6,47.59,14.12,48.79,14.12 M48.79,11.12 c-1.9,0-3.77,0.72-5.34,2.29c-3.5,3.5-2.78,8.48,0.73,11.99l24.17,24.83L35.1,17.81c-1.94-1.94-4.32-3.02-6.65-3.02 c-1.9,0-3.77,0.72-5.34,2.29c-3.5,3.5-2.78,8.48,0.73,11.99L56.46,62.5L29.31,36.04c-1.94-1.94-4.32-3.02-6.65-3.02 c-1.9,0-3.77,0.72-5.34,2.29c-3.5,3.5-2.78,8.48,0.73,11.99l26.56,27.39L28,58.73c-1.94-1.94-4.32-3.02-6.65-3.02 c-1.9,0-3.77,0.72-5.34,2.29c-3.5,3.5-2.07,7.77,1.44,11.29c0,0,40.65,39.64,44.71,42.89c3.49,2.8,9.22,6.34,16.64,6.34 c6.78,0,14.97-2.95,24.15-12.14c24.82-24.82,11.16-40.65,8.39-49.18c-2.57-7.94-8.87-18.9-7.86-26.71 c0.8-6.21,1.77-10.43-3.89-13.08c-0.37-0.18-0.79-0.26-1.23-0.26c-3.2,0-7.9,4.29-9.81,8.83c-1.93,4.58,2.09,13.17,1.72,18.28 c-0.09,1.26-0.6,2.65-1.31,2.65c-0.21,0-0.44-0.12-0.68-0.41c-0.44-0.53-32.83-32.35-32.83-32.35 C53.51,12.21,51.12,11.12,48.79,11.12L48.79,11.12z",
    style: {
      fill: "#EDA600"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_2_",
    d: "M96.6,19.39c-3.39-0.18-8.29,3.03-10.66,8.48c-2,4.58,6.53,20.61,6.53,20.61l-7.26-1.78 c0,0-31.14,61.54-24.47,66.89c6.67,5.35,22.98,12.03,42.21-7.21c24.82-24.82,11.16-40.65,8.39-49.18 c-2.57-7.94-11.42-23.52-8.58-28.97C104.61,24.72,99.46,19.54,96.6,19.39z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_2_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_3_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.88,44.63c-4.77,10.65-2.06,22.47,4.68,34.78c0.93,1.7,2.52,0.87,1.71-0.88 c-8.5-18.2-0.88-34.64-0.88-34.64L87.88,44.63z",
    style: {
      fill: "#EDA600"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M15.64,79.89c1.71,4.93,5.22,8.39,10.34,9.63c2.81,0.68,4.02-3.66,1.2-4.34 c-3.54-0.85-5.99-3.02-7.19-6.48C19.04,75.98,14.69,77.15,15.64,79.89L15.64,79.89z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97,80.88C9.5,91.98,19.85,97.56,31.16,95.32c2.84-0.56,1.64-4.9-1.2-4.34 c-8.83,1.75-16.9-2.64-19.66-11.3C9.43,76.93,5.09,78.1,5.97,80.88L5.97,80.88z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.57,17.37c3.52,0.62,6.36,2.41,7.78,5.79c0.47,1.13,1.48,1.91,2.77,1.57 c1.06-0.28,2.04-1.65,1.57-2.77c-2.02-4.82-5.71-8.02-10.92-8.94C66.94,12.53,65.72,16.87,68.57,17.37L68.57,17.37z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21,7.39c9.07,0.98,14.77,8.33,14.75,17.24c-0.01,2.9,4.49,2.9,4.5,0 c0.03-11.57-7.75-20.49-19.25-21.74C64.34,2.58,64.36,7.08,67.21,7.39L67.21,7.39z",
    style: {
      fill: "#424242"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -91,
    cy: 216,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -71,
    x2: -71,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -111,
    x2: -111,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -91,
    x2: -91,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: 216,
    y2: 216
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: 196,
    y2: 196
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: 235.75,
    y2: 235.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: 280,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -155,
    x2: -27,
    y1: 280,
    y2: 152
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-91,156.26c32.94,0,59.74,26.8,59.74,59.74s-26.8,59.74-59.74,59.74s-59.74-26.8-59.74-59.74 S-123.94,156.26-91,156.26 M-91,156c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60S-57.86,156-91,156L-91,156z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-47.03,267.97h-87.94 c-4.42,0-8.03-3.61-8.03-8.03v-87.91c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C-39,264.36-42.61,267.97-47.03,267.97z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55,276h-72 c-4.4,0-8-3.6-8-8V164c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C-47,272.4-50.6,276-55,276z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41.23,260h-99.54 c-5.63,0-10.23-4.6-10.23-10.23v-67.48c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C-31,255.4-35.6,260-41.23,260z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_36_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: -155,
    y: 152
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_36_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_4_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -183,
    x2: -183,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -179,
    x2: -179,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -175,
    x2: -175,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -171,
    x2: -171,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -167,
    x2: -167,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -163,
    x2: -163,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -159,
    x2: -159,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -155,
    x2: -155,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -151,
    x2: -151,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -147,
    x2: -147,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -143,
    x2: -143,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -139,
    x2: -139,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -135,
    x2: -135,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -131,
    x2: -131,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -127,
    x2: -127,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -123,
    x2: -123,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -119,
    x2: -119,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -115,
    x2: -115,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -111,
    x2: -111,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -107,
    x2: -107,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -103,
    x2: -103,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -99,
    x2: -99,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -95,
    x2: -95,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -91,
    x2: -91,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -87,
    x2: -87,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -83,
    x2: -83,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -79,
    x2: -79,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -75,
    x2: -75,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -71,
    x2: -71,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -67,
    x2: -67,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -63,
    x2: -63,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -59,
    x2: -59,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -55,
    x2: -55,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -51,
    x2: -51,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -47,
    x2: -47,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -43,
    x2: -43,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -39,
    x2: -39,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -35,
    x2: -35,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -31,
    x2: -31,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -27,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -23,
    x2: -23,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -19,
    x2: -19,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -18,
    x2: -18,
    y1: 318.05,
    y2: 126.05
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -11,
    x2: -11,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -7,
    x2: -7,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -3,
    x2: -3,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 1,
    x2: 1,
    y1: 312,
    y2: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 124,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 128,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 132,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 136,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 140,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 144,
    y2: 144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 148,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 152,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 156,
    y2: 156
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 160,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 164,
    y2: 164
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 168,
    y2: 168
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 172,
    y2: 172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 176,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 180,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 184,
    y2: 184
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 188,
    y2: 188
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 192,
    y2: 192
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 196,
    y2: 196
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 200,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 204,
    y2: 204
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 208,
    y2: 208
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 212,
    y2: 212
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 216,
    y2: 216
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 220,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 224,
    y2: 224
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 228,
    y2: 228
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 232,
    y2: 232
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 236,
    y2: 236
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 240,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 244,
    y2: 244
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 248,
    y2: 248
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 252,
    y2: 252
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 256,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 260,
    y2: 260
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 264,
    y2: 264
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 268,
    y2: 268
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 272,
    y2: 272
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 276,
    y2: 276
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 280,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 284,
    y2: 284
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 288,
    y2: 288
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 292,
    y2: 292
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 296,
    y2: 296
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 300,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 304,
    y2: 304
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 308,
    y2: 308
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75,120.25v191.5h-191.5v-191.5H4.75 M5,120h-192v192H5V120L5,120z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: -155,
    y: 152
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: -31,
    y: 152
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 63 245)",
    width: 4,
    x: -93,
    y: 94
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 187 369)",
    width: 4,
    x: -93,
    y: 218
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: -76,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 84,
    x2: 84,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 44,
    x2: 44,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 64,
    x2: 64,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: -76,
    y2: -76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: -96,
    y2: -96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: -56.25,
    y2: -56.25
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: -12,
    y2: -140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 128,
    y1: -12,
    y2: -140
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64-135.74c32.94,0,59.74,26.8,59.74,59.74S96.94-16.26,64-16.26S4.26-43.06,4.26-76S31.06-135.74,64-135.74 M64-136 c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60S97.14-136,64-136L64-136z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.97-24.03H20.03 c-4.42,0-8.03-3.61-8.03-8.03v-87.91c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C116-27.64,112.39-24.03,107.97-24.03z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100-16H28c-4.4,0-8-3.6-8-8 v-104c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C108-19.6,104.4-16,100-16z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.77-32H14.23 C8.6-32,4-36.6,4-42.23v-67.48c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C124-36.6,119.4-32,113.77-32z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_73_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: 0,
    y: -140
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_73_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_5_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -28,
    x2: -28,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -24,
    x2: -24,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -20,
    x2: -20,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -16,
    x2: -16,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -12,
    x2: -12,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -8,
    x2: -8,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -4,
    x2: -4,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 0,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 4,
    x2: 4,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 8,
    x2: 8,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 12,
    x2: 12,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 16,
    x2: 16,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 20,
    x2: 20,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 24,
    x2: 24,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 28,
    x2: 28,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 32,
    x2: 32,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 36,
    x2: 36,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 40,
    x2: 40,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 44,
    x2: 44,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 48,
    x2: 48,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 52,
    x2: 52,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 56,
    x2: 56,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 60,
    x2: 60,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 64,
    x2: 64,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 68,
    x2: 68,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 72,
    x2: 72,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 76,
    x2: 76,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 80,
    x2: 80,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 84,
    x2: 84,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 88,
    x2: 88,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 92,
    x2: 92,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 96,
    x2: 96,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 100,
    x2: 100,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 104,
    x2: 104,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 108,
    x2: 108,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 112,
    x2: 112,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 116,
    x2: 116,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 120,
    x2: 120,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 124,
    x2: 124,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 128,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 132,
    x2: 132,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 136,
    x2: 136,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 137,
    x2: 137,
    y1: 26.05,
    y2: -165.95
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 144,
    x2: 144,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 148,
    x2: 148,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 152,
    x2: 152,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 156,
    x2: 156,
    y1: 20,
    y2: -172
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -168,
    y2: -168
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -164,
    y2: -164
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -160,
    y2: -160
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -156,
    y2: -156
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -152,
    y2: -152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -148,
    y2: -148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -144,
    y2: -144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -140,
    y2: -140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -136,
    y2: -136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -132,
    y2: -132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -128,
    y2: -128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -124,
    y2: -124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -120,
    y2: -120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -116,
    y2: -116
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -112,
    y2: -112
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -108,
    y2: -108
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -104,
    y2: -104
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -100,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -96,
    y2: -96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -92,
    y2: -92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -88,
    y2: -88
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -84,
    y2: -84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -80,
    y2: -80
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -76,
    y2: -76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -72,
    y2: -72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -68,
    y2: -68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -64,
    y2: -64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -60,
    y2: -60
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -56,
    y2: -56
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -52,
    y2: -52
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -48,
    y2: -48
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -44,
    y2: -44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -40,
    y2: -40
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -36,
    y2: -36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -32,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -28,
    y2: -28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -24,
    y2: -24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -20,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -16,
    y2: -16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -12,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -8,
    y2: -8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -4,
    y2: -4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 16,
    y2: 16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.75-171.75v191.5h-191.5v-191.5H159.75 M160-172H-32V20h192V-172L160-172z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 0,
    y: -140
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 124,
    y: -140
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -74 -202)",
    width: 4,
    x: 62,
    y: -198
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 50 -78)",
    width: 4,
    x: 62,
    y: -74
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 44,
    x2: 44,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 64,
    x2: 64,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 44,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 83.75,
    y2: 83.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 128,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64,4.26c32.94,0,59.74,26.8,59.74,59.74S96.94,123.74,64,123.74S4.26,96.94,4.26,64S31.06,4.26,64,4.26 M64,4 C30.86,4,4,30.86,4,64s26.86,60,60,60s60-26.86,60-60S97.14,4,64,4L64,4z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.97,115.97H20.03 c-4.42,0-8.03-3.61-8.03-8.03V20.03c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C116,112.36,112.39,115.97,107.97,115.97z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,124H28c-4.4,0-8-3.6-8-8 V12c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C108,120.4,104.4,124,100,124z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.77,108H14.23 C8.6,108,4,103.4,4,97.77V30.28c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C124,103.4,119.4,108,113.77,108z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_91_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_91_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -28,
    x2: -28,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -24,
    x2: -24,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -20,
    x2: -20,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -16,
    x2: -16,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -12,
    x2: -12,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -8,
    x2: -8,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -4,
    x2: -4,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 0,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 4,
    x2: 4,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 8,
    x2: 8,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 12,
    x2: 12,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 16,
    x2: 16,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 20,
    x2: 20,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 24,
    x2: 24,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 28,
    x2: 28,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 32,
    x2: 32,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 36,
    x2: 36,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 40,
    x2: 40,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 44,
    x2: 44,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 48,
    x2: 48,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 52,
    x2: 52,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 56,
    x2: 56,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 60,
    x2: 60,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 64,
    x2: 64,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 68,
    x2: 68,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 72,
    x2: 72,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 76,
    x2: 76,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 80,
    x2: 80,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 84,
    x2: 84,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 88,
    x2: 88,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 92,
    x2: 92,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 96,
    x2: 96,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 100,
    x2: 100,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 104,
    x2: 104,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 108,
    x2: 108,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 112,
    x2: 112,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 116,
    x2: 116,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 120,
    x2: 120,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 124,
    x2: 124,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 128,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 132,
    x2: 132,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 136,
    x2: 136,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 137,
    x2: 137,
    y1: 166.05,
    y2: -25.95
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 144,
    x2: 144,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 148,
    x2: 148,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 152,
    x2: 152,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 156,
    x2: 156,
    y1: 160,
    y2: -32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -28,
    y2: -28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -24,
    y2: -24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -20,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -16,
    y2: -16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -12,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -8,
    y2: -8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -4,
    y2: -4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 24,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 28,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 36,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 44,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 48,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 52,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 56,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 60,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 68,
    y2: 68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 72,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 76,
    y2: 76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 80,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 84,
    y2: 84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 88,
    y2: 88
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 92,
    y2: 92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 96,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 100,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 104,
    y2: 104
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 108,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 112,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 116,
    y2: 116
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 120,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 124,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 128,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 132,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 136,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 140,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 144,
    y2: 144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 148,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 152,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 156,
    y2: 156
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.75-31.75v191.5h-191.5v-191.5H159.75 M160-32H-32v192h192V-32L160-32z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 124,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 66 -62)",
    width: 4,
    x: 62,
    y: -58
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 190 62)",
    width: 4,
    x: 62,
    y: 66
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 216,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 84,
    x2: 84,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 44,
    x2: 44,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 64,
    x2: 64,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 216,
    y2: 216
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 196,
    y2: 196
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 235.75,
    y2: 235.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 280,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 128,
    y1: 280,
    y2: 152
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64,156.26c32.94,0,59.74,26.8,59.74,59.74S96.94,275.74,64,275.74S4.26,248.94,4.26,216S31.06,156.26,64,156.26 M64,156c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60S97.14,156,64,156L64,156z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.97,267.97H20.03 c-4.42,0-8.03-3.61-8.03-8.03v-87.91c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C116,264.36,112.39,267.97,107.97,267.97z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,276H28c-4.4,0-8-3.6-8-8 V164c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C108,272.4,104.4,276,100,276z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.77,260H14.23 C8.6,260,4,255.4,4,249.77v-67.48c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C124,255.4,119.4,260,113.77,260z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_85_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: 0,
    y: 152
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_85_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_7_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -28,
    x2: -28,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -24,
    x2: -24,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -20,
    x2: -20,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -16,
    x2: -16,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -12,
    x2: -12,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -8,
    x2: -8,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -4,
    x2: -4,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 0,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 4,
    x2: 4,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 8,
    x2: 8,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 12,
    x2: 12,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 16,
    x2: 16,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 20,
    x2: 20,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 24,
    x2: 24,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 28,
    x2: 28,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 32,
    x2: 32,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 36,
    x2: 36,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 40,
    x2: 40,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 44,
    x2: 44,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 48,
    x2: 48,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 52,
    x2: 52,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 56,
    x2: 56,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 60,
    x2: 60,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 64,
    x2: 64,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 68,
    x2: 68,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 72,
    x2: 72,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 76,
    x2: 76,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 80,
    x2: 80,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 84,
    x2: 84,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 88,
    x2: 88,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 92,
    x2: 92,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 96,
    x2: 96,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 100,
    x2: 100,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 104,
    x2: 104,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 108,
    x2: 108,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 112,
    x2: 112,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 116,
    x2: 116,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 120,
    x2: 120,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 124,
    x2: 124,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 128,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 132,
    x2: 132,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 136,
    x2: 136,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 137,
    x2: 137,
    y1: 318.05,
    y2: 126.05
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 144,
    x2: 144,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 148,
    x2: 148,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 152,
    x2: 152,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 156,
    x2: 156,
    y1: 312,
    y2: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 124,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 128,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 132,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 136,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 140,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 144,
    y2: 144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 148,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 152,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 156,
    y2: 156
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 160,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 164,
    y2: 164
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 168,
    y2: 168
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 172,
    y2: 172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 176,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 180,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 184,
    y2: 184
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 188,
    y2: 188
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 192,
    y2: 192
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 196,
    y2: 196
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 200,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 204,
    y2: 204
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 208,
    y2: 208
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 212,
    y2: 212
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 216,
    y2: 216
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 220,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 224,
    y2: 224
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 228,
    y2: 228
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 232,
    y2: 232
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 236,
    y2: 236
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 240,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 244,
    y2: 244
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 248,
    y2: 248
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 252,
    y2: 252
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 256,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 260,
    y2: 260
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 264,
    y2: 264
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 268,
    y2: 268
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 272,
    y2: 272
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 276,
    y2: 276
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 280,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 284,
    y2: 284
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 288,
    y2: 288
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 292,
    y2: 292
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 296,
    y2: 296
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 300,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 304,
    y2: 304
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 308,
    y2: 308
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.75,120.25v191.5h-191.5v-191.5H159.75 M160,120H-32v192h192V120L160,120z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 0,
    y: 152
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 124,
    y: 152
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 218 90)",
    width: 4,
    x: 62,
    y: 94
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 342 214)",
    width: 4,
    x: 62,
    y: 218
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 216,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 226,
    x2: 226,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 186,
    x2: 186,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 206,
    x2: 206,
    y1: 152,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: 216,
    y2: 216
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: 196,
    y2: 196
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: 235.75,
    y2: 235.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: 280,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 142,
    x2: 270,
    y1: 280,
    y2: 152
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206,156.26c32.94,0,59.74,26.8,59.74,59.74s-26.8,59.74-59.74,59.74s-59.74-26.8-59.74-59.74 S173.06,156.26,206,156.26 M206,156c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60S239.14,156,206,156L206,156z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M249.97,267.97h-87.94 c-4.42,0-8.03-3.61-8.03-8.03v-87.91c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C258,264.36,254.39,267.97,249.97,267.97z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,276h-72 c-4.4,0-8-3.6-8-8V164c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C250,272.4,246.4,276,242,276z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,260h-99.54 c-5.63,0-10.23-4.6-10.23-10.23v-67.48c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C266,255.4,261.4,260,255.77,260z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_92_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: 142,
    y: 152
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_92_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_8_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 114,
    x2: 114,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 118,
    x2: 118,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 122,
    x2: 122,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 126,
    x2: 126,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 130,
    x2: 130,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 134,
    x2: 134,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 138,
    x2: 138,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 142,
    x2: 142,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 146,
    x2: 146,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 150,
    x2: 150,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 154,
    x2: 154,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 158,
    x2: 158,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 162,
    x2: 162,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 166,
    x2: 166,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 170,
    x2: 170,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 174,
    x2: 174,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 178,
    x2: 178,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 182,
    x2: 182,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 186,
    x2: 186,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 190,
    x2: 190,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 194,
    x2: 194,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 198,
    x2: 198,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 202,
    x2: 202,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 206,
    x2: 206,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 210,
    x2: 210,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 214,
    x2: 214,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 218,
    x2: 218,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 222,
    x2: 222,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 226,
    x2: 226,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 230,
    x2: 230,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 234,
    x2: 234,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 238,
    x2: 238,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 242,
    x2: 242,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 246,
    x2: 246,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 250,
    x2: 250,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 254,
    x2: 254,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 258,
    x2: 258,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 262,
    x2: 262,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 266,
    x2: 266,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 270,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 274,
    x2: 274,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 278,
    x2: 278,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 279,
    x2: 279,
    y1: 318.05,
    y2: 126.05
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 286,
    x2: 286,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 290,
    x2: 290,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 294,
    x2: 294,
    y1: 312,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 298,
    x2: 298,
    y1: 312,
    y2: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 124,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 128,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 132,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 136,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 140,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 144,
    y2: 144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 148,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 152,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 156,
    y2: 156
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 160,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 164,
    y2: 164
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 168,
    y2: 168
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 172,
    y2: 172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 176,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 180,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 184,
    y2: 184
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 188,
    y2: 188
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 192,
    y2: 192
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 196,
    y2: 196
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 200,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 204,
    y2: 204
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 208,
    y2: 208
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 212,
    y2: 212
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 216,
    y2: 216
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 220,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 224,
    y2: 224
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 228,
    y2: 228
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 232,
    y2: 232
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 236,
    y2: 236
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 240,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 244,
    y2: 244
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 248,
    y2: 248
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 252,
    y2: 252
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 256,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 260,
    y2: 260
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 264,
    y2: 264
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 268,
    y2: 268
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 272,
    y2: 272
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 276,
    y2: 276
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 280,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 284,
    y2: 284
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 288,
    y2: 288
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 292,
    y2: 292
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 296,
    y2: 296
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 300,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 304,
    y2: 304
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 308,
    y2: 308
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M301.75,120.25v191.5h-191.5v-191.5H301.75 M302,120H110v192h192V120L302,120z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 142,
    y: 152
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 266,
    y: 152
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 360 -52)",
    width: 4,
    x: 204,
    y: 94
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 484 72)",
    width: 4,
    x: 204,
    y: 218
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 64,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 226,
    x2: 226,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 186,
    x2: 186,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 206,
    x2: 206,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: 44,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: 83.75,
    y2: 83.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 142,
    x2: 270,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206,4.26c32.94,0,59.74,26.8,59.74,59.74s-26.8,59.74-59.74,59.74S146.26,96.94,146.26,64S173.06,4.26,206,4.26 M206,4c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60S239.14,4,206,4L206,4z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M249.97,115.97h-87.94 c-4.42,0-8.03-3.61-8.03-8.03V20.03c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C258,112.36,254.39,115.97,249.97,115.97z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,124h-72 c-4.4,0-8-3.6-8-8V12c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C250,120.4,246.4,124,242,124z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,108h-99.54 c-5.63,0-10.23-4.6-10.23-10.23V30.28c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C266,103.4,261.4,108,255.77,108z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_86_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: 142,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_86_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_9_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 114,
    x2: 114,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 118,
    x2: 118,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 122,
    x2: 122,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 126,
    x2: 126,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 130,
    x2: 130,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 134,
    x2: 134,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 138,
    x2: 138,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 142,
    x2: 142,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 146,
    x2: 146,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 150,
    x2: 150,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 154,
    x2: 154,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 158,
    x2: 158,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 162,
    x2: 162,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 166,
    x2: 166,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 170,
    x2: 170,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 174,
    x2: 174,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 178,
    x2: 178,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 182,
    x2: 182,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 186,
    x2: 186,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 190,
    x2: 190,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 194,
    x2: 194,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 198,
    x2: 198,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 202,
    x2: 202,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 206,
    x2: 206,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 210,
    x2: 210,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 214,
    x2: 214,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 218,
    x2: 218,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 222,
    x2: 222,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 226,
    x2: 226,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 230,
    x2: 230,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 234,
    x2: 234,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 238,
    x2: 238,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 242,
    x2: 242,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 246,
    x2: 246,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 250,
    x2: 250,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 254,
    x2: 254,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 258,
    x2: 258,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 262,
    x2: 262,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 266,
    x2: 266,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 270,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 274,
    x2: 274,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 278,
    x2: 278,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 279,
    x2: 279,
    y1: 166.05,
    y2: -25.95
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 286,
    x2: 286,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 290,
    x2: 290,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 294,
    x2: 294,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 298,
    x2: 298,
    y1: 160,
    y2: -32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -28,
    y2: -28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -24,
    y2: -24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -20,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -16,
    y2: -16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -12,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -8,
    y2: -8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -4,
    y2: -4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 24,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 28,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 36,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 44,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 48,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 52,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 56,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 60,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 68,
    y2: 68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 72,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 76,
    y2: 76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 80,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 84,
    y2: 84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 88,
    y2: 88
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 92,
    y2: 92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 96,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 100,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 104,
    y2: 104
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 108,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 112,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 116,
    y2: 116
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 120,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 124,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 128,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 132,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 136,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 140,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 144,
    y2: 144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 148,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 152,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 156,
    y2: 156
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.75-31.75v191.5h-191.5v-191.5H301.75 M302-32H110v192h192V-32L302-32z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 142,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 266,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 208 -204)",
    width: 4,
    x: 204,
    y: -58
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 332 -80)",
    width: 4,
    x: 204,
    y: 66
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: -76,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 226,
    x2: 226,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 186,
    x2: 186,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 206,
    x2: 206,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: -76,
    y2: -76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: -96,
    y2: -96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: -56.25,
    y2: -56.25
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 142,
    y1: -12,
    y2: -140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 142,
    x2: 270,
    y1: -12,
    y2: -140
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206-135.74c32.94,0,59.74,26.8,59.74,59.74S238.94-16.26,206-16.26S146.26-43.06,146.26-76S173.06-135.74,206-135.74 M206-136c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60S239.14-136,206-136L206-136z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M249.97-24.03h-87.94 c-4.42,0-8.03-3.61-8.03-8.03v-87.91c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C258-27.64,254.39-24.03,249.97-24.03z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242-16h-72c-4.4,0-8-3.6-8-8 v-104c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C250-19.6,246.4-16,242-16z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77-32h-99.54 C150.6-32,146-36.6,146-42.23v-67.48c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C266-36.6,261.4-32,255.77-32z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_80_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: 142,
    y: -140
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_80_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_10_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 114,
    x2: 114,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 118,
    x2: 118,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 122,
    x2: 122,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 126,
    x2: 126,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 130,
    x2: 130,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 134,
    x2: 134,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 138,
    x2: 138,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 142,
    x2: 142,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 146,
    x2: 146,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 150,
    x2: 150,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 154,
    x2: 154,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 158,
    x2: 158,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 162,
    x2: 162,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 166,
    x2: 166,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 170,
    x2: 170,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 174,
    x2: 174,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 178,
    x2: 178,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 182,
    x2: 182,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 186,
    x2: 186,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 190,
    x2: 190,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 194,
    x2: 194,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 198,
    x2: 198,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 202,
    x2: 202,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 206,
    x2: 206,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 210,
    x2: 210,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 214,
    x2: 214,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 218,
    x2: 218,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 222,
    x2: 222,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 226,
    x2: 226,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 230,
    x2: 230,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 234,
    x2: 234,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 238,
    x2: 238,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 242,
    x2: 242,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 246,
    x2: 246,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 250,
    x2: 250,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 254,
    x2: 254,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 258,
    x2: 258,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 262,
    x2: 262,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 266,
    x2: 266,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 270,
    x2: 270,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 274,
    x2: 274,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 278,
    x2: 278,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 279,
    x2: 279,
    y1: 26.05,
    y2: -165.95
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 286,
    x2: 286,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 290,
    x2: 290,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 294,
    x2: 294,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 298,
    x2: 298,
    y1: 20,
    y2: -172
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -168,
    y2: -168
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -164,
    y2: -164
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -160,
    y2: -160
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -156,
    y2: -156
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -152,
    y2: -152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -148,
    y2: -148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -144,
    y2: -144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -140,
    y2: -140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -136,
    y2: -136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -132,
    y2: -132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -128,
    y2: -128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -124,
    y2: -124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -120,
    y2: -120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -116,
    y2: -116
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -112,
    y2: -112
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -108,
    y2: -108
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -104,
    y2: -104
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -100,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -96,
    y2: -96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -92,
    y2: -92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -88,
    y2: -88
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -84,
    y2: -84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -80,
    y2: -80
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -76,
    y2: -76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -72,
    y2: -72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -68,
    y2: -68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -64,
    y2: -64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -60,
    y2: -60
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -56,
    y2: -56
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -52,
    y2: -52
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -48,
    y2: -48
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -44,
    y2: -44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -40,
    y2: -40
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -36,
    y2: -36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -32,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -28,
    y2: -28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -24,
    y2: -24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -20,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -16,
    y2: -16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -12,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -8,
    y2: -8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: -4,
    y2: -4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 110,
    x2: 302,
    y1: 16,
    y2: 16
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M301.75-171.75v191.5h-191.5v-191.5H301.75 M302-172H110V20h192V-172L302-172z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 142,
    y: -140
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 266,
    y: -140
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 68 -344)",
    width: 4,
    x: 204,
    y: -198
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 192 -220)",
    width: 4,
    x: 204,
    y: -74
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -91,
    cy: -76,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -71,
    x2: -71,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -111,
    x2: -111,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -91,
    x2: -91,
    y1: -140,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: -76,
    y2: -76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: -96,
    y2: -96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: -56.25,
    y2: -56.25
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: -12,
    y2: -140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -155,
    x2: -27,
    y1: -12,
    y2: -140
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-91-135.74c32.94,0,59.74,26.8,59.74,59.74S-58.06-16.26-91-16.26s-59.74-26.8-59.74-59.74S-123.94-135.74-91-135.74 M-91-136c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60S-57.86-136-91-136L-91-136z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-47.03-24.03h-87.94 c-4.42,0-8.03-3.61-8.03-8.03v-87.91c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C-39-27.64-42.61-24.03-47.03-24.03z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55-16h-72c-4.4,0-8-3.6-8-8 v-104c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C-47-19.6-50.6-16-55-16z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41.23-32h-99.54 C-146.4-32-151-36.6-151-42.23v-67.48c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C-31-36.6-35.6-32-41.23-32z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: -155,
    y: -140
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_11_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_12_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -183,
    x2: -183,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -179,
    x2: -179,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -175,
    x2: -175,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -171,
    x2: -171,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -167,
    x2: -167,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -163,
    x2: -163,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -159,
    x2: -159,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -155,
    x2: -155,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -151,
    x2: -151,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -147,
    x2: -147,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -143,
    x2: -143,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -139,
    x2: -139,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -135,
    x2: -135,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -131,
    x2: -131,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -127,
    x2: -127,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -123,
    x2: -123,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -119,
    x2: -119,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -115,
    x2: -115,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -111,
    x2: -111,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -107,
    x2: -107,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -103,
    x2: -103,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -99,
    x2: -99,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -95,
    x2: -95,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -91,
    x2: -91,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -87,
    x2: -87,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -83,
    x2: -83,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -79,
    x2: -79,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -75,
    x2: -75,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -71,
    x2: -71,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -67,
    x2: -67,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -63,
    x2: -63,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -59,
    x2: -59,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -55,
    x2: -55,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -51,
    x2: -51,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -47,
    x2: -47,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -43,
    x2: -43,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -39,
    x2: -39,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -35,
    x2: -35,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -31,
    x2: -31,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -27,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -23,
    x2: -23,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -19,
    x2: -19,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -18,
    x2: -18,
    y1: 26.05,
    y2: -165.95
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -11,
    x2: -11,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -7,
    x2: -7,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -3,
    x2: -3,
    y1: 20,
    y2: -172
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 1,
    x2: 1,
    y1: 20,
    y2: -172
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -168,
    y2: -168
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -164,
    y2: -164
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -160,
    y2: -160
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -156,
    y2: -156
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -152,
    y2: -152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -148,
    y2: -148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -144,
    y2: -144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -140,
    y2: -140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -136,
    y2: -136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -132,
    y2: -132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -128,
    y2: -128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -124,
    y2: -124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -120,
    y2: -120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -116,
    y2: -116
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -112,
    y2: -112
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -108,
    y2: -108
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -104,
    y2: -104
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -100,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -96,
    y2: -96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -92,
    y2: -92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -88,
    y2: -88
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -84,
    y2: -84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -80,
    y2: -80
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -76,
    y2: -76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -72,
    y2: -72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -68,
    y2: -68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -64,
    y2: -64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -60,
    y2: -60
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -56,
    y2: -56
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -52,
    y2: -52
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -48,
    y2: -48
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -44,
    y2: -44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -40,
    y2: -40
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -36,
    y2: -36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -32,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -28,
    y2: -28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -24,
    y2: -24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -20,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -16,
    y2: -16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -12,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -8,
    y2: -8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -4,
    y2: -4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 16,
    y2: 16
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75-171.75v191.5h-191.5v-191.5H4.75 M5-172h-192V20H5V-172L5-172z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: -155,
    y: -140
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: -31,
    y: -140
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -229 -47)",
    width: 4,
    x: -93,
    y: -198
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -105 77)",
    width: 4,
    x: -93,
    y: -74
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -91,
    cy: 64,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -71,
    x2: -71,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -111,
    x2: -111,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -91,
    x2: -91,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: 44,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: 83.75,
    y2: 83.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -155,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -155,
    x2: -27,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-91,4.26c32.94,0,59.74,26.8,59.74,59.74s-26.8,59.74-59.74,59.74s-59.74-26.8-59.74-59.74S-123.94,4.26-91,4.26 M-91,4c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60S-57.86,4-91,4L-91,4z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-47.03,115.97h-87.94 c-4.42,0-8.03-3.61-8.03-8.03V20.03c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C-39,112.36-42.61,115.97-47.03,115.97z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55,124h-72 c-4.4,0-8-3.6-8-8V12c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C-47,120.4-50.6,124-55,124z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41.23,108h-99.54 c-5.63,0-10.23-4.6-10.23-10.23V30.28c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C-31,103.4-35.6,108-41.23,108z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: -155,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_17_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_13_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -183,
    x2: -183,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -179,
    x2: -179,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -175,
    x2: -175,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -171,
    x2: -171,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -167,
    x2: -167,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -163,
    x2: -163,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -159,
    x2: -159,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -155,
    x2: -155,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -151,
    x2: -151,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -147,
    x2: -147,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -143,
    x2: -143,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -139,
    x2: -139,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -135,
    x2: -135,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -131,
    x2: -131,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -127,
    x2: -127,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -123,
    x2: -123,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -119,
    x2: -119,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -115,
    x2: -115,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -111,
    x2: -111,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -107,
    x2: -107,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -103,
    x2: -103,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -99,
    x2: -99,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -95,
    x2: -95,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -91,
    x2: -91,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -87,
    x2: -87,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -83,
    x2: -83,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -79,
    x2: -79,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -75,
    x2: -75,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -71,
    x2: -71,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -67,
    x2: -67,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -63,
    x2: -63,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -59,
    x2: -59,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -55,
    x2: -55,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -51,
    x2: -51,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -47,
    x2: -47,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -43,
    x2: -43,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -39,
    x2: -39,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -35,
    x2: -35,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -31,
    x2: -31,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -27,
    x2: -27,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -23,
    x2: -23,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -19,
    x2: -19,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -18,
    x2: -18,
    y1: 166.05,
    y2: -25.95
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -11,
    x2: -11,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -7,
    x2: -7,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -3,
    x2: -3,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 1,
    x2: 1,
    y1: 160,
    y2: -32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -28,
    y2: -28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -24,
    y2: -24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -20,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -16,
    y2: -16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -12,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -8,
    y2: -8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: -4,
    y2: -4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 24,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 28,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 36,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 44,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 48,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 52,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 56,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 60,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 68,
    y2: 68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 72,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 76,
    y2: 76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 80,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 84,
    y2: 84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 88,
    y2: 88
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 92,
    y2: 92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 96,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 100,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 104,
    y2: 104
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 108,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 112,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 116,
    y2: 116
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 120,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 124,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 128,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 132,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 136,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 140,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 144,
    y2: 144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 148,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 152,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -187,
    x2: 5,
    y1: 156,
    y2: 156
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75-31.75v191.5h-191.5v-191.5H4.75 M5-32h-192v192H5V-32L5-32z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: -155,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: -31,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -89 93)",
    width: 4,
    x: -93,
    y: -58
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 35 217)",
    width: 4,
    x: -93,
    y: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.4f3d64c099852add63e4cbe9540a2349.svg";
export { ForwardRef as ReactComponent };